import { render, staticRenderFns } from "./xwv2.vue?vue&type=template&id=51b1d78b&scoped=true"
import script from "./xwv2.vue?vue&type=script&lang=js"
export * from "./xwv2.vue?vue&type=script&lang=js"
import style0 from "./xwv2.vue?vue&type=style&index=0&id=51b1d78b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51b1d78b",
  null
  
)

export default component.exports